import axiosInstance from '../../common/axios.service';
import type FILTERS from '../../common/filters.type';
import type {MAIN_FILTER, UPDATE_COLUMNS} from './liveBatteries.type';

const config = () => {
  return axiosInstance.get('dashboard/config').then((response) => {
    return response;
  });
};
const liveBatteriesColoumnUpdate = (payload: UPDATE_COLUMNS) => {
  return axiosInstance.post('dashboard/columns', payload).then((response) => {
    return response;
  });
};

const liveBatteriesList = (payload: {body: MAIN_FILTER; filters: FILTERS}) => {
  return axiosInstance
    .post('dashboard/batterylist', payload.body, {params: payload.filters})
    .then((response) => {
      return response;
    });
};

const liveBatteriesCSV = (payload: MAIN_FILTER) => {
  return axiosInstance.post('dashboard/batterycsv', payload).then((response) => {
    return response;
  });
};
const batteryDetails = (payload: {asset_id: string}) => {
  return axiosInstance.post('dashboard/batterydetaildata', payload).then((response) => {
    return response;
  });
};

const liveBatteriesServices = {
  config,
  liveBatteriesColoumnUpdate,
  liveBatteriesList,
  liveBatteriesCSV,
  batteryDetails,
};

export default liveBatteriesServices;
